import { useFormikContext } from 'formik'
import { Box, Grid, Skeleton } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  TextInputWithHelper,
  MediaInput,
  FormSubmitButton,
  FormImage,
  HelperWrapper,
  LocaleSelect,
  ScannersAssociationInput,
} from 'src/components'
import { ImpactsAssociationInput, AccountsAssociationInput, CodeInput } from '../inputs'
import {
  DescriptionRichInput,
  DescriptionSimpleInput,
} from 'src/components/products/product-form/fields'
import { useAccount } from 'src/hooks'
import { MobileEditButtons } from './mobile-edit-buttons.component'
import { ETranslationNs, IStepForm, EAccountSubscriptionPlans } from 'src/types'

import useStyles from '../styles'
import { Locations } from 'src/components/locaions'

interface IProps {
  isDisabled?: boolean
  locale?: string
  handleLocale?: (locale: string) => void
}

const FormEdit = ({ isDisabled, locale, handleLocale }: IProps) => {
  const [t] = useTranslation()
  const { values, handleChange, errors, setFieldValue } = useFormikContext<IStepForm>()
  const { data: account, isLoading: isAccountLoading } = useAccount()
  const classes = useStyles()

  // const handleDescriptionGenerate = (value: string) => setFieldValue('description', value)

  const freeAccount = account?.subscription_plan === EAccountSubscriptionPlans.free

  return (
    <Grid className={classes.form}>
      <Grid className={classes.formWrapper} container>
        <Grid className={classes.mainImageWrapper}>
          <FormImage alt={values.name} />
        </Grid>
        {locale && handleLocale && (
          <Box
            sx={{
              pt: '10px',
              px: '5px',
              alignSelf: 'start',
            }}
          >
            <LocaleSelect locale={locale} handleLocale={handleLocale} />
          </Box>
        )}
        <Grid className={classes.upperInputWrapper} container item>
          <TextInputWithHelper
            disabled={isDisabled}
            inputName="name"
            handleChange={handleChange}
            value={values.name}
            error={errors.name ? t(errors.name + '.v') : ''}
            inputPlaceholder={t('steps-form-name-input-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'steps-form-name-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
          <CodeInput isDisabled={isDisabled} />
        </Grid>
        <Grid className={classes.descriptionWrapper}>
          {isAccountLoading ? (
            <Skeleton variant="rectangular" height={230} width="100%" />
          ) : freeAccount ? (
            <DescriptionSimpleInput
              isRequired={false}
              isDisabled={isDisabled}
              locale={locale}
              textPrompt={`${t('steps-form-ai-prompt.v')} ${values.name || '{step name}'} ${t(
                'products-form-ai-prompt-1.v',
              )} ${account?.account_holder || '{account name}'} ${t(
                'products-form-ai-prompt-2.v',
              )} ${account?.region || '{account region}'} ${
                account?.country || '{account country}'
              }`}
              generationType="Step"
            />
          ) : (
            <DescriptionRichInput
              isRequired={false}
              isDisabled={isDisabled}
              locale={locale}
              textPrompt={`${t('steps-form-ai-prompt.v')} ${values.name || '{step name}'} ${t(
                'products-form-ai-prompt-1.v',
              )} ${account?.account_holder || '{account name}'} ${t(
                'products-form-ai-prompt-2.v',
              )} ${account?.region || '{account region}'} ${
                account?.country || '{account country}'
              }`}
              generationType="Step"
            />
          )}
        </Grid>
        {/* <Grid className={classes.inputWrapper}>
          <TextInputWithHelper
            disabled={isDisabled}
            inputName="description"
            handleChange={handleChange}
            value={values.description}
            error={errors.description ? t(errors.description + '.v') : ''}
            inputPlaceholder={t('description-input-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'description-input-label'}
                ns={ETranslationNs.Common}
                isMandatory
                isColorInherited
                size={10}
              />
            }
            multiline={true}
          />
          <GenerateAIButton
            generationType="Step"
            setGeneratedValue={handleDescriptionGenerate}
            isDisabled={isDisabled}
          />
        </Grid> */}
        <Locations
          isDisabled={isDisabled}
          errors={errors}
          locations={values.locations}
          setFieldValue={setFieldValue}
        />

        <MediaInput
          disabled={isDisabled}
          inputName="media"
          media={values.media}
          setFieldValue={setFieldValue}
          mainImageSwitch
          withDnd
        />
        <ImpactsAssociationInput isDisabled={isDisabled} />

        <ScannersAssociationInput<IStepForm>
          description={<HelperWrapper t="scanners-association-title" isColorInherited size={12} />}
          isDisabled={isDisabled}
        />

        <AccountsAssociationInput isDisabled={isDisabled} />
        <MobileEditButtons isDisabled={isDisabled} />
      </Grid>
      <FormSubmitButton
        disabled={isDisabled}
        validText={
          <HelperWrapper t="save-changes-button-text" ns={ETranslationNs.Form} isColorInherited />
        }
        invalidText={<HelperWrapper t="steps-form-submit-button-edit" isColorInherited />}
      />
    </Grid>
  )
}

export { FormEdit }
